import { createFileRoute } from '@tanstack/react-router';
import { SrHub } from '@/features/service-reports/SrHub';

export const Route = createFileRoute('/_app/service-reports')({ component: SrHub });

// Rapportini d'intervento (Service Report) — modello HR enterprise v2, JSON:API + workflow
// (create-and-send / send / cancel / acknowledge). Il rapportino è uno snapshot dell'invio
// al cliente di una voce di timesheet, non del lavoro svolto.
